import { ALL_VIEW_COLUMNS } from "./all-view-columns.constants";

const cs = ALL_VIEW_COLUMNS;

export const DEFAULT_VIEW_COLUMNS = [
    cs.accountNumber,
    cs.name,
    cs.email,
    cs.street,
    cs.city,
    cs.city,
    cs.uuid,
    cs.monitoredStatus,
    cs.onlineStatus,
];

export const DEFAULT_PM_VIEW_COLUMNS = [
    cs.accountNumber,
    cs.uuid,
    cs.isOccupied,
    cs.name,
    cs.street,
    cs.street2,
    cs.zipcode,
    cs["home-communities"],
    cs.onlineStatus,
    cs.monitoredStatus,
];

export const DEFAULT_COORDINATOR_VIEW_COLUMNS = [
    cs.accountNumber,
    cs.uuid,
    cs.isOccupied,
    cs.name,
    cs.street,
    cs.street2,
    cs.zipcode,
    cs["home-communities"],
    cs.onlineStatus,
];
